

const briefcaseRoutes = {
  path: "mybriefcase",

  // Lazy-load the layout (so BriefcaseLayout doesn't land in main.js)
  lazy: async () => {
    const mod = await import("components/UI/BriefcaseLayout");
    const BriefcaseLayout = mod.default;
    return { Component: BriefcaseLayout };
  },

  children: [
    {
      index: true, // instead of path: ""
      lazy: async () => {
        const mod = await import("views/Admin/Briefcase");
        const MyBriefCase = mod.default;
        return { Component: MyBriefCase };
      },
    },
    {
      path: "details/:spaceId",
      lazy: async () => {
        const mod = await import("views/Admin/Briefcase/BriefcaseDetails");
        const BriefcaseDetails = mod.default;
        return { Component: BriefcaseDetails };
      },
    },
    {
      path: "details/:spaceId/:fileId",
      lazy: async () => {
        const mod = await import("views/Admin/Workspace/WorkspaceDocumentDetails");
        const WorkspaceDocumentDetails = mod.default;
        return { Component: WorkspaceDocumentDetails };
      },
    },
  ],
};

export default briefcaseRoutes;
